import React, {useCallback} from 'react'
import {
  getEventTicketLimitPerOrder,
  hasSeatingPlan,
  isRegistrationClosedVisible,
  saleStartedAndHasTickets,
} from '@wix/wix-events-commons-statics'
import {PricingOption} from '@wix/ambassador-wix-events-web/types'
import {Quantity} from '../../fields/quantity'
import {usePageActions, usePageStateSelector} from '../../../../../hooks/state'
import {getSelectedTicketQuantity, getSelectedTicketsQuantity} from '../../../../../selectors/selected-tickets'

export const PricingOptionQuantity = ({
  ticket,
  pricingOption,
  className,
}: {
  ticket: wix.events.ticketing.TicketDefinition
  pricingOption: PricingOption
  className?: string
}) => {
  const event = usePageStateSelector(state => state.event)
  const registrationClosed = isRegistrationClosedVisible(event)
  const withSeatingPlan = hasSeatingPlan(event)
  const maxTicketsPerReservation = getEventTicketLimitPerOrder(event)
  const totalSelectedQuantity = usePageStateSelector(state => getSelectedTicketsQuantity(state))
  const selectedPricingOptionQuantity = usePageStateSelector(state =>
    getSelectedTicketQuantity(state, ticket.id, pricingOption.id),
  )
  const selectedWholeTicketQuantity = usePageStateSelector(state => getSelectedTicketQuantity(state, ticket.id))

  const availableTicketsQuantity = maxTicketsPerReservation - totalSelectedQuantity
  const ticketLimit = ticket.limitPerCheckout - selectedWholeTicketQuantity + selectedPricingOptionQuantity
  const orderLimit = availableTicketsQuantity + selectedPricingOptionQuantity
  const max = Math.min(orderLimit, ticketLimit)

  const readonly = !saleStartedAndHasTickets(ticket) || registrationClosed || withSeatingPlan

  const {selectTicket} = usePageActions()

  const onSelectCount = useCallback((count: number) => {
    selectTicket({ticketId: ticket.id, count, pricingOptionId: pricingOption.id})
  }, [])

  if (readonly) {
    return null
  }

  return (
    <div className={className}>
      <Quantity max={max} value={selectedPricingOptionQuantity} onSelectCount={onSelectCount} />
    </div>
  )
}
